<template>
  <div
    v-if="dialog.latestMessage"
    class="tw-py-4 tw-px-5 tw-rounded"
    :class="dialog.isUnread ? 'tw-bg-indigo-50' : 'tw-bg-true-gray-100'"
  >
    <WdsStack class="tw-text-gray-700 tw-mb-1">
      {{ latestMessageDatetime ? $t(':plural ago', { plural: latestMessageDatetime }) : '' }}
      <div class="separator tw-mx-2" />
      {{ $tc(':count message', dialog.messages.paginatorInfo.total) }}
    </WdsStack>
    <!-- eslint-disable vue/no-v-html -->
    <p
      v-if="latestMessageBody && latestMessageBody.length !== 0"
      class="m-0 tw-line-clamp-4"
      v-html="latestMessageBody"
    ></p>
    <p v-else class="m-0">
      <em class="c-gray">
        {{ $t('No message') }}
      </em>
    </p>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { WdsStack } from '@worksome/wds-components'
import { graphqlFragmentValidator } from '@/utils/propValidation'

const JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_DIALOG = gql`
  fragment JobPageDialogsItemMessageFragmentForDialog on Dialog {
    isUnread
    latestMessage {
      parsedBody
      autobody
      createdAt
    }
    messages {
      paginatorInfo {
        total
      }
    }
  }
`

export default {
  components: {
    WdsStack,
  },
  props: {
    dialog: {
      type: Object,
      required: true,
      validator: graphqlFragmentValidator(JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_DIALOG),
    },
  },
  fragments: {
    dialog: JOB_PAGE_DIALOGS_ITEM_FRAGMENT_FOR_DIALOG,
  },
  computed: {
    latestMessageBody() {
      if (!this.dialog.latestMessage) {
        return null
      }
      const { parsedBody } = this.dialog.latestMessage
      return parsedBody && parsedBody.length > 0 ? parsedBody : this.dialog.latestMessage.autobody
    },
    latestMessageDatetime() {
      if (!this.dialog.latestMessage) {
        return null
      }
      return window.moment
        .duration(window.moment().diff(this.dialog.latestMessage.createdAt))
        .humanize()
    },
  },
}
</script>

<style scoped>
.separator:before {
  content: '\B7';
}
</style>
